import React from 'react';
import { MapPin } from 'lucide-react';

const COLORS = {
  emerald: { hover: 'hover:bg-emerald-50', bg: 'bg-emerald-600', text: 'group-hover:text-emerald-600' },
  blue: { hover: 'hover:bg-blue-50', bg: 'bg-blue-600', text: 'group-hover:text-blue-600' },
  orange: { hover: 'hover:bg-orange-50', bg: 'bg-orange-600', text: 'group-hover:text-orange-600' },
  yellow: { hover: 'hover:bg-yellow-50', bg: 'bg-yellow-600', text: 'group-hover:text-yellow-600' },
};

export const OfficeCard = ({ office, color, testId }) => {
  const c = COLORS[color] || COLORS.emerald;
  return (
    <a href={office.mapUrl} target="_blank" rel="noopener noreferrer" className={`p-4 bg-gray-50 rounded-xl ${c.hover} transition-colors group`} data-testid={testId}>
      <div className="flex items-center gap-3 mb-2">
        <div className={`w-8 h-8 ${c.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
          <MapPin className="w-4 h-4 text-white" />
        </div>
        <h4 className={`font-semibold text-gray-900 text-sm ${c.text} transition-colors`}>{office.name}</h4>
      </div>
      <p className="text-gray-600 text-xs leading-relaxed pl-11">{office.address}</p>
    </a>
  );
};

export const OfficeMapCard = ({ office, color, title }) => {
  const c = COLORS[color] || COLORS.emerald;
  return (
    <a href={office.mapUrl} target="_blank" rel="noopener noreferrer" className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow group">
      <div className="aspect-video relative">
        <iframe
          src={`https://www.google.com/maps?q=${encodeURIComponent(office.address)}&output=embed`}
          width="100%"
          height="100%"
          style={{ border: 0, pointerEvents: 'none' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={title}
        ></iframe>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <span className={`opacity-0 group-hover:opacity-100 transition-opacity ${c.bg} text-white px-4 py-2 rounded-lg font-medium shadow-lg`}>
            Open in Google Maps
          </span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{office.name}</h3>
        <p className="text-gray-600 text-sm">{office.address}</p>
      </div>
    </a>
  );
};
